export const openApplyLinkInNewTab = ():void => {
    const applyButtons = document.querySelectorAll<HTMLAnchorElement>('.jobApplyBtn')
    applyButtons.forEach((button) => {
        button.setAttribute('target', '_blank')
    })
}   